import {
  Box,
  Card,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme
} from '@mui/material';
import type { FC } from 'react';
import type { IIsPdf, TapTaintedData } from '../../models';
import { AvaniLightTheme } from '../../theme/schemes/AvaniLightTheme';
import { AvaniTaintPieChart } from '../Charts';
import { AvaniTaintProfilesDialog } from '../Dialogs';

interface AvaniTaintCardProps extends IIsPdf {
  tainted: number;
  total: number;
  perTap: TapTaintedData[];
}

const AvaniStyledCard = styled(Card)(
  () => `
  border-radius: 16px;
  padding: 16px;

  .MuiTypography-root.MuiTypography-h3 {
    margin: 0;
    line-height: 1;
    padding-bottom: 24px;
  }
`
);

export const AvaniTaintCard: FC<AvaniTaintCardProps> = ({ total, tainted, perTap, isPDF }) => {
  const theme = isPDF ? AvaniLightTheme : useTheme();

  return (
    <AvaniStyledCard
      raised={true}
      sx={{ height: '100%', backgroundColor: theme.colors.avani.lightTurc, ['.MuiPieArc-root']: { stroke: 'none' } }}
    >
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h3" color={theme.colors.avani.teal}>
            Taint Profiles Per Tap
          </Typography>
          <Box sx={{ display: 'flex' }}>
            <Box>
              <AvaniTaintPieChart tainted={tainted} noTaint={total} />
            </Box>
            <Box sx={{ flexGrow: 1, padding: 2 }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: 'transparent' }}>
                    <TableCell sx={{ textTransform: 'none' }}>Bar</TableCell>
                    <TableCell sx={{ textTransform: 'none' }}>Tap</TableCell>
                    <TableCell sx={{ textTransform: 'none' }}>Product</TableCell>
                    <TableCell sx={{ textTransform: 'none' }}>Taint Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!!perTap &&
                    perTap.map((item, i) => {
                      return (
                        <TableRow key={item.barName + item.tapName + item.productName + i}>
                          <TableCell>{item.barName}</TableCell>
                          <TableCell>{item.tapName}</TableCell>
                          <TableCell>{item.productName}</TableCell>
                          <TableCell>{item.tapTaintProfile}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </Box>
        <span>
          <AvaniTaintProfilesDialog />
        </span>
      </Box>
    </AvaniStyledCard>
  );
};
